module.exports = "/_next/static/images/LinkedProfiles@2x-bf777c464f683c0025ee04e8c9f3267e.png";